import { gql, GraphQLClient } from 'graphql-request'

export const graphQLClient = new GraphQLClient(
  `/acs/v2/lending/cc/apply/graphql`,
)

export const creditCardOfferQuery = gql`
  query CustomerCardOffer($customerId: ID!) {
    customerCardOffer(input: { customerId: $customerId }) {
      isOfferAvailable
      offerDetails {
        offerId
        productId
        presented
        productType
      }
    }
  }
`

export const creditCardOfferMutation = gql`
  mutation CustomerCardOffer($customerId: ID!, $offerId: ID!) {
    setOfferPresented(input: { customerId: $customerId, offerId: $offerId }) {
      isSuccessful
    }
  }
`
